import { memo } from "react";
import { DecryptedText } from "../../../components/intake-modal/decrypted-text";
import * as css from "../../../components/intake-modal/intake-modal.module.css";

export interface StepTitleProps {
  animate?: boolean;
  scrambleSpeed?: number;
  scramble?: boolean;
  text: string;
}

export const StepTitle = memo(function StepTitle({
  animate = true,
  scramble = false,
  scrambleSpeed = 28,
  text,
}: StepTitleProps) {
  return (
    <h1 className={css.title}>
      {animate && scramble ? (
        <DecryptedText
          animateOn="mount"
          sequential
          speed={scrambleSpeed}
          text={text}
        />
      ) : (
        text
      )}
    </h1>
  );
});
